import parse from 'html-react-parser';

export const sortDataByAlphabet = (
    data: { skillName: string }[],
    sortOrder: string
) => {
    const copiedData = [...data];
    return copiedData.sort(
        (a: { skillName: string }, b: { skillName: string }) => {
            if (sortOrder === 'A to Z') {
                return a.skillName.localeCompare(b.skillName);
            }
            return b.skillName.localeCompare(a.skillName);
        }
    );
};

export const sortDataByDate = (data: any, sortOrder: string) => {
    const copiedData = [...data];
    return copiedData.sort((a: any, b: any) => {
        if (sortOrder === 'Newest First') {
            return (
                new Date(b.dateUpdated).getTime() -
                new Date(a.dateUpdated).getTime()
            );
        }
        return (
            new Date(a.dateUpdated).getTime() -
            new Date(b.dateUpdated).getTime()
        );
    });
};

export const getParsedContent = (selector: string, content: string) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(content, 'application/xml');
    const element = xmlDoc.querySelector(selector);
    return element ? parse(element.innerHTML) : null;
};

export const formatDate = (dateElement: any | null) => {
    if (dateElement) {
        const dateParts = dateElement.split('-');
        if (dateParts.length === 3) {
            return `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
        }
    }
    return null;
};

export const isLatestStateEquivalentToRestored = (
    latestState: any,
    restoredState: any
): boolean => {
    const resettableFields = [
        'ageSpecific',
        'subType',
        'category',
        'speciality',
    ];

    const latestKeys = Object.keys(latestState);
    const restoredKeys = Object.keys(restoredState);

    const allKeysMatch = latestKeys.every((key) => {
        if (resettableFields.includes(key)) {
            const latestVal = latestState[key];
            const restoredVal = restoredState[key];
            const latestIsEmpty = latestVal === '' || latestVal == null;
            const restoredIsEmpty = restoredVal === '' || restoredVal == null;
            if (latestIsEmpty && restoredIsEmpty) return true;
            if (latestIsEmpty || restoredIsEmpty) return true;
            return latestVal === restoredVal;
        }
        if (
            typeof latestState[key] === 'object' &&
            latestState[key] !== null &&
            restoredState[key] !== null
        ) {
            return (
                JSON.stringify(latestState[key]) ===
                JSON.stringify(restoredState[key])
            );
        }
        return latestState[key] === restoredState[key];
    });

    const allRestoredKeysInLatest = restoredKeys.every((key) =>
        latestKeys.includes(key)
    );

    return allKeysMatch && allRestoredKeysInLatest;
};
